import {
  authTokenGet,
  webviewAccessTokenGet,
  languageBrowser,
  deviceIdGet,
  getCacheVPN,
} from "@codestreet/utils";

import type { ApiRequestHeaders } from "./client.types";

export function headersBase(
  webview: boolean,
  providedHeaders: ApiRequestHeaders,
) {
  const token = webview ? webviewAccessTokenGet() : authTokenGet()?.accessToken;
  const headers: { [key: string]: string } = {
    "X-Application": providedHeaders.application || "",
    "X-Version-Backend": providedHeaders.version_backend || "",
    "X-Device-Id": deviceIdGet(),
    Locale: languageBrowser(),
    Authorization: token ? `Bearer ${token}` : "",
  };

  if (getCacheVPN() !== undefined) {
    headers["X-Vpn"] = String(getCacheVPN());
  }
  return headers;
}
